<section id="about" class="content">
    <div class="wrapper">
        <h2>Hello, is it me <br/>you’re looking for?</h2>
        <p>G’day, my name’s Brodie <span class="emoji">👋</span></p>
        <p>
            I’m a designer and product engineer based in Sydney, Australia.
            I like long walks on the beach, candlelit dinners with my computer, and music that confuses my
            grandmother.
        </p>
        <p>
            I’ve been crafting websites and digital experiences since I was a teenager.
            Over the years it’s turned from a hobby, to a passion, and now into a career.
        </p>
        <p>
            I’m currently working as the Technical Lead at <a href="https://www.mirai.au/">Mirai</a>.
        </p>
        <p>
            Wanna know more? You’ve come to the right place! Keep scrolling.
        </p>
    </div>
</section>